import React, {useState} from 'react';
import {db} from '../firebase/firebaseConfig';
import {ref, push, set} from "firebase/database";
import {ContenedorFiltros, Contenedor, Formulario, Input, ContenedorSubtitulo, Subtitulo, ContenedorBoton} from './../elementos/ElementosConductores';
import Boton from './../elementos/Boton';
import {ReactComponent as IconoPlus} from './../imagenes/plus.svg';
import Alerta from './../elementos/Alerta'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faIdCard,faPhone,faEnvelope,faUser, faToggleOn,faUserTag,faMapLocation,faComment} from '@fortawesome/free-solid-svg-icons';
import SelectEstadoConductor from './SelectEstadoConductor';


const FormularioCreaCliente = ({estadoCrear, CambiarEstadoCrear}) => {
    const [alerta, cambiarAlerta] = useState({});
    const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
    const [nombre, cambiarNombre] = useState('');
    const [nombrecorto, cambiarNombrecorto] = useState('');
    const [telefono, cambiarTelefono] = useState('');
    const [correo, cambiarCorreo] = useState('');
    const [rut, cambiarRut] = useState('');
    const [direccion, cambiarDireccion] = useState('');
    const [estado, cambiarEstado] = useState('Seleccione Estado');
    const [comentario, cambiarComentario] = useState('');

const handleChange = (e) => {
    if(e.target.name === 'nombre'){
        cambiarNombre(e.target.value);
    } else if (e.target.name === 'nombre_corto'){
        cambiarNombrecorto(e.target.value);
    } else if (e.target.name === 'telefono'){
        cambiarTelefono(e.target.value);
    } else if (e.target.name === 'correo'){
        cambiarCorreo(e.target.value);
    } else if (e.target.name === 'rut'){
        cambiarRut(e.target.value);
    } else if (e.target.name === 'direccion'){
        cambiarDireccion(e.target.value);
    }  else if (e.target.name === 'estado'){
        cambiarEstado(e.target.value);
    } else if (e.target.name === 'comentario'){
        cambiarComentario(e.target.value);
    } 
}

const handleSubmit = async (e) => {
    e.preventDefault();

    if(nombre === '' || nombre === undefined ){
        cambiarEstadoAlerta(true); 
        cambiarAlerta({tipo: 'error', mensaje: 'Por favor ingresa nombre' }); return;}
    if(nombrecorto === '' || nombrecorto === undefined ){
        cambiarEstadoAlerta(true); 
        cambiarAlerta({tipo: 'error', mensaje: 'Por favor ingresa nombre corto' }); return;}
    if(telefono === '' || telefono === undefined ){
        cambiarEstadoAlerta(true); 
        cambiarAlerta({tipo: 'error', mensaje: 'Por favor ingresa telefono' }); return;}
    if(correo === '' || correo === undefined ){
        cambiarEstadoAlerta(true); 
        cambiarAlerta({tipo: 'error', mensaje: 'Por favor ingresa Email' }); return;}
    if(rut === '' || rut === undefined ){
        cambiarEstadoAlerta(true); 
        cambiarAlerta({tipo: 'error', mensaje: 'Por favor ingresa RUT' }); return;}
    if(direccion === '' || direccion === undefined ){
        cambiarEstadoAlerta(true); 
        cambiarAlerta({tipo: 'error', mensaje: 'Por favor ingresa direccion' }); return;}
    if(estado === 'Seleccione Estado' || estado === undefined ){
        cambiarEstadoAlerta(true); 
        cambiarAlerta({tipo: 'error', mensaje: 'Por favor selecciona Estado' }); return;}


    const postListRef = ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/clientes');
    const newPostRef = push(postListRef);
    await set(newPostRef, {
        nombre: nombre,
        nombrecorto: nombrecorto,
        telefono: telefono,
        correo: correo,
        rut: rut,
        direccion: direccion,
        estado: estado,
        comentario: comentario

    }); 
    cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: 'exito',
                    mensaje: 'Cliente Creado con Exito'
                });
                cambiarNombre('');
                cambiarNombrecorto('');
                cambiarTelefono('');
                cambiarCorreo('');
                cambiarRut('');
                cambiarDireccion('');
                cambiarEstado('Seleccione Estado');
                cambiarComentario('');
                CambiarEstadoCrear(true);
}
 
    return (  
        <Formulario onSubmit={handleSubmit}>
            <Contenedor>

            <div hidden={estadoCrear}>
                <ContenedorSubtitulo><Subtitulo>Informacion para Crear Cliente</Subtitulo></ContenedorSubtitulo>    
            {/* Campos de Cliente}*/}
                <ContenedorFiltros><FontAwesomeIcon icon={faUser}/><Input name="nombre" type="text" placeholder="Nombre" value={nombre} onChange={handleChange}/></ContenedorFiltros>    
                <ContenedorFiltros><FontAwesomeIcon icon={faUserTag}/><Input name="nombre_corto" type="text" placeholder="Nombre Corto" value={nombrecorto} onChange={handleChange}/></ContenedorFiltros>    
                <ContenedorFiltros><FontAwesomeIcon icon={faPhone}/><Input name="telefono" type="text" placeholder="Telefono" value={telefono} onChange={handleChange} /></ContenedorFiltros>   
                <ContenedorFiltros><FontAwesomeIcon icon={faEnvelope}/><Input name="correo" type="text" placeholder="E-mail"  value={correo} onChange={handleChange} /></ContenedorFiltros>
                <ContenedorFiltros><FontAwesomeIcon icon={faIdCard}/><Input name="rut" type="text" placeholder="RUT" value={rut} onChange={handleChange} /></ContenedorFiltros>
                <ContenedorFiltros><FontAwesomeIcon icon={faMapLocation}/><Input name="direccion" type="text" placeholder="Direccion" value={direccion} onChange={handleChange} /></ContenedorFiltros>    
                <ContenedorFiltros><FontAwesomeIcon icon={faToggleOn}/><SelectEstadoConductor estado={estado} cambiarEstado={cambiarEstado}/></ContenedorFiltros>
                <ContenedorFiltros><FontAwesomeIcon icon={faComment}/><Input name="comentario" type="text" placeholder="Comentario"  value={comentario} onChange={handleChange}/></ContenedorFiltros>
                <ContenedorBoton ><Boton as="button" primario conIcono type="submit"> Crear &nbsp;&nbsp;<IconoPlus/></Boton>
                </ContenedorBoton> 
            <Alerta tipo={alerta.tipo} mensaje={alerta.mensaje} estadoAlerta={estadoAlerta} cambiarEstadoAlerta={cambiarEstadoAlerta} />
            </div>

            </Contenedor>
            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                cambiarEstadoAlerta={cambiarEstadoAlerta}
            />
        </Formulario>
    );
}

export default FormularioCreaCliente;